
import { httpRequest } from "../../http";

export class CommandMeetingToNote {
    async run(meetingId: string, notebookId: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/recordings/?use_mock=false`
        try {
            const response = await httpRequest<any>(url, { method: "POST", body: { meeting_id: meetingId, notebook_id: notebookId } });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

